import * as Yup from 'yup'

export const NutriTableFormSchema = Yup.object().shape({
  standard_cut: Yup.string().required()
})
export type NutriTableFormYup = Yup.InferType<typeof NutriTableFormSchema>
